export const showModalMapDelivery = () => ({
  type: "SHOW_MODAL_MAP_DELIVERY",
});

export const closeModalMapDelivery = () => ({
  type: "CLOSE_MODAL_MAP_DELIVERY",
});
